import { useEffect, useState } from "react";
import { authService } from "../services/api";
import { currencyLabelOf, marketOf, normalizeLatamBase, normalizeMode } from "../utils/market";

/**
 * Retorna a moeda-base do funil do bot (espelha pix_config.currency_mode).
 * Usado para rotular preços (planos, order bumps) sem duplicar a regra.
 *
 * @param {string|number} botId
 * @returns {{ currencyMode: 'brl'|'usd'|'mxn', baseCurrency: string, currencySymbol: string, currencyLabel: string, loading: boolean }}
 */
export function useBotCurrency(botId) {
    const [currencyMode, setCurrencyMode] = useState('brl');
    const [latamBase, setLatamBase] = useState('MXN'); // LATAM: moeda em que os valores são escritos
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        if (!botId) {
            setLoading(false);
            return;
        }
        (async () => {
            try {
                const { data } = await authService.bots.edit_bot(botId);
                const pc = data?.bot?.pix_config;
                if (alive) {
                    setCurrencyMode(normalizeMode(pc?.currency_mode));
                    setLatamBase(normalizeLatamBase(pc?.latam_base_currency));
                }
            } catch {
                if (alive) setCurrencyMode('brl');
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, [botId]);

    // Sincroniza quando a moeda-base é trocada em outro lugar (aba Pagamentos).
    useEffect(() => {
        const onChanged = (e) => {
            if (!botId || String(e.detail?.botId) !== String(botId)) return;
            if (e.detail?.mode) setCurrencyMode(normalizeMode(e.detail.mode));
            if (e.detail?.base) setLatamBase(normalizeLatamBase(e.detail.base));
        };
        window.addEventListener('bot-currency-changed', onChanged);
        return () => window.removeEventListener('bot-currency-changed', onChanged);
    }, [botId]);

    return {
        currencyMode,
        baseCurrency: latamBase,
        currencySymbol: marketOf(currencyMode, latamBase).code,
        currencyLabel: currencyLabelOf(currencyMode, latamBase),
        loading,
    };
}
